import { memo } from 'react'

const SampleCard = memo(function SampleCard({ image, title }) {
    const mobileSrc = image.replace(/\.webp$/, '_mobile.webp')
    return (
        <div className="card MMP-sample-image mx-auto shadow-lg my-2 border-secondary" style={{width: "90%"}}>
            <img
                src={image}
                srcSet={`${mobileSrc} 600w, ${image} 1200w`}
                sizes="(max-width: 575px) 90vw, (max-width: 767px) 45vw, 30vw"
                alt={title}
                className="card-img-top"
                loading="lazy"
                style={{width: "100%", height: "auto"}}
            />
            <div className="card-body">
                <p className="card-text small text-muted">{title}</p>
            </div>
        </div>
    )
})

export default SampleCard